import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./recommendation_experiment_type.js";
//#region src/recommendation_experiment_type_helper.ts
var recommendation_experiment_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(experimentType) {
	switch (experimentType) {
		case "none": return "None";
		case "item-view-recommendation-level": return "Item View Recommendation Level";
		case "rule-based": return "Rule Based";
	}
}
//#endregion
export { name, recommendation_experiment_type_helper_exports };

//# sourceMappingURL=recommendation_experiment_type_helper.js.map